import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Form } from 'react-bootstrap'

import Button from 'components/Button'
import FormControl from 'components/Form/FormControl'

const friendlyErrorMessage = (error, providerName) => {
  if (!error) return null
  if (error.statusCode === 401 || error.statusCode === 422) {
    return `The ${providerName} API key was rejected. Double-check that you copied it correctly and try again.`
  }
  if (error.statusCode === 504) {
    return `${providerName} didn't respond in time. Please try again in a moment.`
  }
  if (error.statusCode === 502) {
    return `Couldn't reach ${providerName}. Please try again in a moment.`
  }
  return (
    error.message ||
    'Could not connect. Please check your credentials and try again.'
  )
}

const ConnectForm = ({
  provider,
  onSubmit,
  isSubmitting,
  error
}) => {
  const [values, setValues] = useState(() =>
    (provider.credentialFields || []).reduce((acc, f) => {
      acc[f.key] = ''
      return acc
    }, {})
  )

  const handleChange = key => e =>
    setValues(prev => ({ ...prev, [key]: e.target.value }))

  const handleSubmit = e => {
    e.preventDefault()
    onSubmit(values)
  }

  return (
    <Form onSubmit={handleSubmit}>
      {(provider.credentialFields || []).map(field => (
        <div key={field.key} className="mb-15">
          <label
            htmlFor={`connect-${provider.key}-${field.key}`}
            className="font-weight-bold mb-5"
          >
            {field.label}
          </label>
          <FormControl
            type={field.type || 'text'}
            name={field.key}
            value={values[field.key]}
            onChange={handleChange(field.key)}
            placeholder={field.label}
          />
          {field.helpText && (
            <small className="text-gray-dark">
              {field.helpText}
            </small>
          )}
        </div>
      ))}

      {error && (
        <p className="text-danger mb-15">
          {friendlyErrorMessage(error, provider.name)}
        </p>
      )}

      <Button
        variant="secondary"
        type="submit"
        disabled={isSubmitting}
        smallPadding
      >
        {isSubmitting
          ? 'Connecting…'
          : `Connect ${provider.name}`}
      </Button>
    </Form>
  )
}

ConnectForm.propTypes = {
  provider: PropTypes.shape({
    key: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    credentialFields: PropTypes.array
  }).isRequired,
  onSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool,
  error: PropTypes.object
}

export default ConnectForm
